module.exports = __webpack_public_path__ + "cover-letter-47f61a13/cover-letter-1-preview-d69fa21cc97e7b7feb470976fb6a2bfe.jpg";